// ------------------------------------------------------------------------ //
//  IMPORT
// ------------------------------------------------------------------------ //
import React, { useState } from 'react';
import { TextField, Button, Typography } from '@material-ui/core';
import dayjs from 'dayjs';
import useStyles from '@shared/styles/Memo';
import TableMemo from '@features/memo/components/TableMemo';
import { useUserMemo, useCreateUserMemo } from '@features/memo/hooks/useMemoQueries';

// ------------------------------------------------------------------------ //
//  COMPONENT
// ------------------------------------------------------------------------ //
const TabMemo = () => {
  const classes = useStyles();
  const [description, setDescription] = useState('');
  const [date, setDate] = useState(dayjs().add(30, 'minute').format('YYYY-MM-DDTHH:mm'));

  // Utilisation des hooks React Query
  const { data: memo = [] } = useUserMemo();
  const createMemoMutation = useCreateUserMemo();

  const handleCreateMemo = () => {
    createMemoMutation.mutate(
      { date, description },
      {
        onSuccess: () => {
          // Réinitialiser le formulaire après succès
          setDescription('');
          setDate(dayjs().add(30, 'minute').format('YYYY-MM-DDTHH:mm'));
        }
      }
    );
  };

  return (
    <div>
      <Typography variant="h5" className={classes.title}>
        Ajouter un nouveau mémo :
      </Typography>
      <div className={classes.row}>
        <TextField
          className={classes.inputDescription}
          margin="dense"
          id="description"
          variant="outlined"
          label="Description du mémo"
          value={description}
          onChange={(event) => {
            setDescription(event.target.value);
          }}
        />
        <TextField
          className={classes.inputDate}
          id="date"
          label="Date du mémo"
          type="datetime-local"
          margin="dense"
          variant="outlined"
          value={date}
          onChange={(event) => {
            setDate(event.target.value);
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <Button
          variant="contained"
          margin="dense"
          color="secondary"
          disabled={!description || createMemoMutation.isLoading}
          onClick={handleCreateMemo}
        >
          {createMemoMutation.isLoading ? 'Ajout...' : 'Ajouter'}
        </Button>
      </div>
      <TableMemo memo={memo} />
    </div>
  );
};

export default TabMemo;

